var map = {
	"./cwiczenie-80px.png": "5d71",
	"./film-80px.png": "c61c",
	"./galeria-80px.png": "dbef",
	"./kolorowanka-80px.png": "64a9",
	"./muzyka-80px.png": "4c8d",
	"./pdf-80px.png": "a16b",
	"./plansza-80px.png": "e45a",
	"./puzzle-80px.png": "ea4f",
	"./tekst-80px.png": "6bea"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5c7a";